import './../css/aos.css';
import './../css/bootstrap.min.css';
import './../css/main.css';
import { DetailsPhoto } from './../DetailsPhoto/detailsPhoto';
import { educationEngineerTextList, educationAnalyticTextList } from '../../Utils/data';

export const DetailsEducation = ({handleOnClick}) => {
    return (
        <div class="page-content details-education" onClick={handleOnClick}>
            <div class="container">
                <div class="cover shadow-lg bg-white">
                    <div class="cover-bg p-3 p-lg-4 text-white">
                        <div class="row">
                        </div>
                    </div>
                </div>
                <div class="cover-title shadow-lg bg-dark text-light">
                    <div class="education-section px-3-custom px-lg-4 pb-4">
                        <h2 class="h3 mb-4 text-dark">Education</h2>
                        <div class="timeline">
                            <div class="timeline-card timeline-card-success card shadow-sm bg-secondary">
                                <div class="card-body">
                                <div class="h5 mb-1">Software Engineer <span class="text-greeny h6">from Universidad Abierta Interamericana (UAI), Argentina.</span></div>
                                <div class="text-white text-small mb-2">2008 - 2014</div>
                                <div>
                                    The career provided me with tools to:
                                    <ul>
                                        {educationEngineerTextList.map((bullet, index) => (
                                        <li key={index}>{bullet}</li>
                                        ))}
                                    </ul></div>
                                </div>
                            </div>
                            <div class="timeline-card timeline-card-success card shadow-sm bg-secondary">
                                <div class="card-body">
                                <div class="h5 mb-1">Software Analyst <span class="text-greeny h6">from Universidad Abierta Interamericana (UAI), Argentina.</span></div>
                                <div class="text-white text-small mb-2">2008 - 2011</div>
                                <div>
                                    Halfway degree of the main career that trained me to:
                                    <ul>
                                        {educationAnalyticTextList.map((bullet, index) => (
                                        <li key={index}>{bullet}</li>
                                        ))}
                                    </ul></div>
                                </div>
                            </div>
                        </div>
                        <DetailsPhoto />
                    </div>
                </div>
            </div>
        </div>
    )
}